module.exports = __webpack_public_path__ + "static/media/img26.bd4e10a4.JPG";